import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import ScreenHeading from '../../utilities/ScreenHeading/ScreenHeading';

const containerStyle = {
  width: '100%',
  height: '400px',
};

const center = {
  lat: 44.77194265137031, // Latitude kancelarije (promeni u stvarnu)
  lng: 17.18067915554354, // Longitude kancelarije (promeni u stvarnu) 44.77194265137031, 17.18067915554354
};

const Map = (props) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyCJXNZPTiFc5eYKDEwvtCeTEdHLHWKi45A', // Zameni sa stvarnim API ključem
  });

  if (!isLoaded) return <p>Učitavanje mape...</p>;

  return (
    <><div id={props.id}>
        <ScreenHeading 
      title={'Lokacija'}
      subHeading={'Posjetite nas'}
      />
      </div><GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
              <Marker position={center} />
          </GoogleMap></>
  );
};

export default Map;
